<template>
	<!-- <button class="base-btn" disabled v-if="!hasDraftStarted">
		Draft as not started yet
	</button> -->

	<button
		class="is_available base-btn"
		v-if="isMyTurn && !is_picked(player.id)"
		@click="pick_player(player.id)"
	>
		pick is available
	</button>
	<button class="base-btn" disabled v-else-if="!isMyTurn">
		Not Your Turn Yet
	</button>
	<button class="base-btn" disabled v-else>
		picked by {{ player.picked_by_name }}
	</button>
</template>

<style lang="scss" scoped>
.is_available {
	@apply bg-blue-600 hover:bg-blue-900;
}

.not_your_turn {
	@apply bg-gray-600 hover:bg-gray-900;
}
</style>

<script>
import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters(['isMyTurn', 'is_picked']),
	},
	props: {
		player: Object,
		room_id: String,
	},
	methods: {
		pick_player(player_id) {
			this.$store.commit('pick_player', player_id);
		},
	},
};
</script>
